import React, { useState, useEffect } from 'react';
import './Landing.css';
import Navbar from './components/Navbar';
import IntroSection from './components/IntroSection';
import HeroSection from './components/HeroSection';
import StepsSection from './components/StepsSection';
import TheoreticalSection from './components/TheoreticalSection';
import FinalSection from './components/FinalSection';
import RequirementsSection from './components/RequirementsSection';
import ProgramSection from './components/ProgramSection';
import InfoSection from './components/InfoSection';
import DocumentsSection from './components/DocumentsSection';
import Footer from './components/Footer';
import RegistrationModal from './components/RegistrationModal';
import LoginModal from './components/LoginModal';
import { AuthService } from './services/auth.service';
import { isRegistrationOpen } from './config/featureFlags';

const Landing: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    // Проверяем, залогинен ли пользователь при загрузке
    const user = AuthService.getUser();
    if (user) {
      setIsLoggedIn(true);
    }

    // Подписываемся на изменения статуса авторизации
    const unsubscribe = AuthService.subscribe((loggedIn) => {
      setIsLoggedIn(loggedIn);
    });

    // Отписываемся при размонтировании компонента
    return () => {
      unsubscribe();
    };
  }, []);

  const handleOpenModal = () => {
    if (isRegistrationOpen()) {
      setIsModalOpen(true);
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleShowLogin = () => {
    setIsModalOpen(false);
    setShowLoginModal(true);
  };

  const handleLoginSuccess = () => {
    setIsLoggedIn(true);
    setShowLoginModal(false);
  };

  return (
    <div className="landing">
      <Navbar />
      
      {/* Первый слайд */}
      <IntroSection />

      {/* Второй слайд */}
      <HeroSection onOpenRegistration={handleOpenModal} isLoggedIn={isLoggedIn} />

      {/* Третий слайд */}
      <StepsSection />

      {/* Четвертый слайд */}
      <TheoreticalSection isLoggedIn={isLoggedIn} />

      {/* Пятый слайд */}
      <FinalSection />

      {/* Шестой слайд */}
      <RequirementsSection />

      {/* Седьмой слайд */}
      <ProgramSection />

      {/* Восьмой слайд */}
      <InfoSection />

      {/* Девятый слайд */}
      <DocumentsSection />

      {/* Footer */}
      <Footer />

      <RegistrationModal 
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onShowLogin={handleShowLogin}
      />

      <LoginModal
        isOpen={showLoginModal}
        onClose={() => setShowLoginModal(false)}
        onSuccess={handleLoginSuccess}
      />
    </div>
  );
};

export default Landing;
